import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { IoReload } from "react-icons/io5";
import { translations } from "../../../helpers";
import { BsEye, BsPencil } from "../../../assets/icons/vander";
import { useDoctorsStore } from "../../../hooks";
import {
  SelectForm,
  LoadingData,
  ErrorMessage,
  SuccessMessage,
} from "../../ui";
import { paginationOptions } from "../../data";
import { ModalViewDoctor, ModalEditDoctor } from "./";

export const DoctorsTable = () => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    isLoadingData,
    doctors,
    message,
    page,
    pageSize,
    totalPages,

    // Methods
    startGetDoctors,
    startChangePageSize,
    startChangePage,
    startAddPage,
    startRemovePage,
    reloadDoctors,
  } = useDoctorsStore();

  // States ------------------------------------------------//
  const [viewDoctor, setViewDoctor] = useState(false);
  const [editDoctor, setEditDoctor] = useState(false);
  const [doctor, setDoctor] = useState(null);

  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  const onChangePageSize = ({ target }) => {
    startChangePageSize(target.value);
  };

  const onChangePage = (page) => {
    startChangePage(page);
  };

  // Efectos -----------------------------------------------//
  useEffect(() => {
    if (doctors.length === 0) {
      startGetDoctors(page, pageSize);
    }
  }, [doctors.length, startGetDoctors, page, pageSize]);

  useEffect(() => {
    if (!editDoctor) {
      setDoctor(null);
    }
  }, [editDoctor]);

  return (
    <>
      <div className="row text-center mb-4">
        <div className="col-12 mt-4">
          <div className="d-md-flex align-items-end text-center justify-content-between">
            <SelectForm
              label={`Registros por página`}
              options={paginationOptions}
              labelKey={"description"}
              name={`pageSize`}
              value={pageSize}
              onInputChange={onChangePageSize}
            />

            <ul className="pagination justify-content-center mb-0 mt-3 mt-sm-0">
              <Link
                to="#"
                className="btn btn-icon btn-pills btn-soft-primary me-4"
                onClick={() => {
                  reloadDoctors();
                }}
              >
                <IoReload />
              </Link>
              <li className="page-item" onClick={() => startRemovePage()}>
                <Link className="page-link" to="#" aria-label="Previous">
                  &lt;
                </Link>
              </li>
              {Array.from({ length: totalPages }, (_, index) => (
                <li
                  key={index}
                  className={`page-item ${
                    parseInt(page) === index + 1 ? "active" : ""
                  }`}
                  onClick={() => onChangePage((index + 1).toString())}
                >
                  <Link className={`page-link`} to="#">
                    {index + 1}
                  </Link>
                </li>
              ))}
              <li className="page-item" onClick={() => startAddPage()}>
                <Link className="page-link" to="#" aria-label="Next">
                  &gt;
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {isLoadingData && <LoadingData className="mb-4" />}
      {message?.type === "errorDoctors" && (
        <ErrorMessage className="mb-4">{message.text}</ErrorMessage>
      )}
      {message?.type === "success" && (
        <SuccessMessage className="mb-4">{message.text}</SuccessMessage>
      )}

      <div
        className="table-responsive shadow rounded"
        style={{ fontFamily: "Inter, sans-serif" }}
      >
        <table className="table table-center bg-white mb-0">
          <thead>
            <tr>
              <th className="border-bottom p-3" style={{ minWidth: "50px" }}>
                #
              </th>
              <th className="border-bottom p-3">Documento</th>
              <th className="border-bottom p-3">Nombres</th>
              <th className="border-bottom p-3">Apellidos</th>
              <th className="border-bottom p-3" style={{ maxWidth: "180px" }}>
                Email
              </th>
              <th className="border-bottom p-3"># Celular</th>
              <th className="border-bottom p-3">Ciudad</th>
              <th className="border-bottom p-3">Dirección</th>
              <th className="border-bottom p-3">Estado</th>
              <th
                className="border-bottom p-3"
                style={{ minWidth: "100px" }}
              ></th>
            </tr>
          </thead>
          <tbody>
            {doctors.map((doctor, index) => (
              <tr key={doctor.id}>
                <th className="p-3">{index + 1}</th>
                <td className="py-3">{doctor.document}</td>
                <td className="py-3">{doctor.firstName}</td>
                <td className="py-3">{doctor.lastName}</td>
                <td
                  className="py-3 text-break"
                  style={{
                    minWidth: "180px",
                    fontFamily: "Inter, sans-serif",
                  }}
                >
                  {doctor.email}
                </td>
                <td className="py-3">{doctor.phoneNumber}</td>
                <td className="py-3">{doctor.city}</td>
                <td className="py-3">{doctor.address}</td>
                <td className="py-3">
                  <span
                    className={`p-2 rounded-pill text-center ${
                      doctor.stateName === "ACTIVE"
                        ? "bg-soft-success"
                        : doctor.stateName === "INACTIVE"
                        ? "bg-soft-danger"
                        : "bg-soft-warning"
                    }`}
                  >
                    {translations[doctor.stateName] || doctor.stateName}
                  </span>
                </td>
                <td className="text-end p-3">
                  <button
                    style={{ width: "24px" }}
                    className="btn btn-icon fs-lg text-gray-400"
                    onClick={() => {
                      setDoctor(doctor);
                      setViewDoctor(true);
                    }}
                  >
                    <BsEye />
                  </button>
                  <button
                    style={{ width: "24px" }}
                    className="btn btn-icon fs-lg text-gray-300"
                    onClick={() => {
                      setDoctor(doctor);
                      setEditDoctor(true);
                    }}
                  >
                    <BsPencil />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <ModalViewDoctor
        viewDoctor={viewDoctor}
        setViewDoctor={setViewDoctor}
        doctor={doctor}
      />

      <ModalEditDoctor
        editDoctor={editDoctor}
        setEditDoctor={setEditDoctor}
        doctor={doctor}
      />
    </>
  );
};
